var _path, _path2, _path3, _rect, _rect2, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 100,
    viewBox: "0 0 106 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.597656 40.9697H105.403V83.7718C105.403 92.6088 98.2389 99.7725 89.4019 99.7725H16.5984C7.76145 99.7725 0.597656 92.6087 0.597656 83.7718V40.9697Z",
    fill: "#356733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.529 12.6385C55.0627 10.8392 50.9376 10.8392 47.4713 12.6385L4.19738 35.1013C1.9857 36.2493 0.597656 38.5337 0.597656 41.0256C0.597656 43.6669 2.15514 46.0598 4.5703 47.1291L48.3183 66.4985C51.2999 67.8186 54.7004 67.8186 57.682 66.4985L101.43 47.1291C103.845 46.0598 105.403 43.6669 105.403 41.0256C105.403 38.5337 104.015 36.2493 101.803 35.1013L58.529 12.6385Z",
    fill: "#234522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9989 0.967773C19.4642 0.967773 16.5986 3.83329 16.5986 7.36808V52.4542L48.3185 66.4981C51.3002 67.8182 54.7006 67.8182 57.6822 66.4981L89.4021 52.4542V7.36808C89.4021 3.83329 86.5366 0.967773 83.0018 0.967773H22.9989Z",
    fill: "#FFD456"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.1992,
    y: 11.7686,
    width: 25.6012,
    height: 6.39201,
    rx: 1.60008,
    fill: "#FEFEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1992,
    y: 47.9883,
    width: 31.0885,
    height: 6.39201,
    rx: 1.60008,
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1992 25.4419C26.1992 24.5582 26.9156 23.8418 27.7993 23.8418H78.2017C79.0854 23.8418 79.8018 24.5582 79.8018 25.4419V28.6337C79.8018 29.5174 79.0854 30.2338 78.2017 30.2338H27.7993C26.9156 30.2338 26.1992 29.5174 26.1992 28.6337V25.4419Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1992 37.5161C26.1992 36.6324 26.9156 35.916 27.7993 35.916H67.4012C68.2849 35.916 69.0013 36.6324 69.0013 37.5161V40.708C69.0013 41.5916 68.2849 42.308 67.4012 42.308H27.7993C26.9156 42.308 26.1992 41.5916 26.1992 40.708V37.5161Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.f46b2f180acf25fca4cf45717ac8f1ba.svg";
export { ForwardRef as ReactComponent };